import {AfterViewInit, Component, OnInit} from '@angular/core';
// import {MenuItem, PrimeIcons} from 'primeng/api';
import {KeycloakService} from 'keycloak-angular';
import {Apollo} from 'apollo-angular';
import {gql} from '@apollo/client/core';
import {Route, Router} from '@angular/router';
import {KeycloakUser} from './model/model';
import {NgxPermissionsService} from 'ngx-permissions';
import {MenuItem} from 'primeng/api';
import {PayslipCollectionSegment, Query} from "../service/graphql";

const checkRegistered = gql`
  query {
    isRegistered
  }`;

const CLIENT_ACCESS_QUERY = gql`
  query ($entityID: UUID){
    clientModules (
      where: {
        CLIENT: {
          CLIENT_BILLINGS: {
            some: {
              ENTITY_CLIENT_BILLINGS: {
                some: {
                  ENTITY_ID: {
                    eq: $entityID
                  }
                }
              }
            }
          }
        }
      }
    ) {
      CLIENT {
        CLIENT_BILLINGS {
          ENTITY_CLIENT_BILLINGS {
            ENTITY_ID
          }
        }
      }
      HR_MODULE {
        MODULE_NAME
        MODULE_ID
      }
    }
  }
`;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Financia';
  items: MenuItem[] = [];
  appUser: KeycloakUser | undefined;
  isUserLoggedIn = false;
  sidebarState = false;
  currentRoute = "";
  currentTitle = "";
  isSideNavMaximize = true;
  isAdmin = false;

  constructor(private keycloakService: KeycloakService,
              private router: Router,
              private permissionService: NgxPermissionsService,
              private apollo: Apollo,) {

    this.keycloakService.isLoggedIn().then(async (x) => {
      this.isUserLoggedIn = x;

      const userRole = keycloakService.getUserRoles();

      // if (userRole.includes('ADMINISTRATOR')){
      //   window.location.pathname = '/';
      // }else if (userRole.includes('MEMBER')){
      //   window.location.pathname = '/member';
      // }
      
      // if (this.isUserLoggedIn) {
      //   this.keycloakService.getKeycloakInstance().loadUserInfo().then(async r => {
      //     const m: any = r;
      //     this.permissionService.loadPermissions(m.Roles);
      // this.permissionService.loadPermissions(this.keycloakService.getUserRoles(true));

      // console.log('permissions boi', this.permissionService.getPermissions());

      this.isAdmin = await this.permissionService.hasPermission(['ADMINISTRATOR']);

      if (this.currentRoute.includes("admin/lms")){
        this.items = [...this.items,
          {
            label: 'Admin',
            routerLink: ['admin/users'],
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
            items: [
              {
                label: 'Home',
                routerLink: ['admin/lms/home'],
                icon: 'fa-regular fa-objects-column',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'LMS.ADMIN']),
              },
              // {
              //   label: 'Announcement',
              //   routerLink: ['admin/lms/announcement'],
              //   icon: 'fa-regular fa-bullhorn',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              // },
              {
                label: 'Trainings',
                routerLink: ['admin/lms/trainings'],
                icon: 'fa-regular fa-graduation-cap',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'LMS.ADMIN']),
              },
              // {
              //   label: 'Lessons',
              //   routerLink: ['admin/lms/lessons'],
              //   icon: 'fa-regular fa-book',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              // },
              {
                label: 'Tests',
                routerLink: ['admin/lms/quiz'],
                icon: 'fa-regular fa-lightbulb',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'LMS.ADMIN']),
              },
              // {
              //   label: 'Assignment',
              //   routerLink: ['admin/lms/assignment'],
              //   icon: 'fa-regular fa-clipboard',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              // },
              // {
              //   label: 'Grades',
              //   routerLink: ['admin/lms/grades'],
              //   icon: 'fa-regular fa-award',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              // },
              // {
              //   label: 'Enrollment',
              //   routerLink: ['admin/lms/enrollment'],
              //   icon: 'fa-regular fa-files',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              // },
              {
                label: 'Certificates',
                routerLink: ['admin/lms/certificates'],
                icon: 'fa-regular fa-file-certificate',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'LMS.ADMIN']),
              },
              // {
              //   label: 'Members',
              //   routerLink: ['admin/lms/members'],
              //   icon: 'fa-regular fa-group',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'LMS.ADMIN']),
              // },
              // {
              //   label: 'Settings',
              //   routerLink: ['lms/setting'],
              //   icon: 'fa-regular fa-gear',
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              // },
              {
                label: 'Sign Out',
                routerLink: ['signout'],
                icon: 'fa-regular fa-square-left',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              },
            ]
          },
        ];
      }else {
        this.items = [
          ...this.items,
          {
            label : 'Dashboard',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
            title: 'dashboard',
            routerLink: [''],
            icon: 'fa-solid fa-table-columns',
          },
          // {
          //   label : 'Overtime',
          //   routerLink: ['admin/approve'],
          //   icon: 'fa-solid fa-clock',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
          //   title: 'overtime',
          //   expanded: false,
          //   items : [
          //     // {
          //     //   label: 'Overtime',
          //     //   routerLink: ['admin/approve'],
          //     //   icon: 'fa-solid fa-clock',
          //     //   visible: true
          //     // },
          //     {
          //       label: 'Requests',
          //       routerLink: ['admin/approve'],
          //       icon: 'fa-solid fa-clock',
          //       visible: true,
          //       title: 'overtime',
          //     },
          //     {
          //       label: 'Timesheet',
          //       routerLink: ['admin/timesheet'],
          //       icon: 'fa-solid fa-calendar-plus',
          //       visible: true,
          //       title: 'overtime',
          //     }
          //   ]
          // },
          // {
          //   label : 'Accomplishments',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
          //   items : [
          //     {
          //       label: 'Report',
          //       routerLink: ['accomplishment/reports'],
          //       icon: 'fa-solid fa-bar-chart',
          //       visible: true
          //     }
          //   ]
          // },
          {
            label: 'Employees',
            routerLink: ['member/roster'],
            icon: 'fa-solid fa-person',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ROSTER.ADMIN', 'ROSTER.WRITE', 'ROSTER.READ', 'APPLICANT.ADMIN', 'APPLICANT.WRITE', 'APPLICANT.READ', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ']),
            title: 'member',
            expanded: false,
            items: [
              {
                label: 'Roster',
                routerLink: ['member/roster'],
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ROSTER.ADMIN', 'ROSTER.WRITE', 'ROSTER.READ']),
                title: 'member',
              },
              {
                label: 'Applicants',
                routerLink: ['member/applicants'],
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'APPLICANT.ADMIN', 'APPLICANT.WRITE', 'APPLICANT.READ']),
                title: 'member',
              },
              // {
              //   label: 'Deductions',
              //   routerLink: ['member/deductions-overview'],
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'DEDUCTION.ADMIN', 'DEDUCTION.WRITE', 'DEDUCTION.READ']),
              //   title: 'member',
              // },
              // {
              //   label: 'Disbursements',
              //   routerLink: ['member/disbursement-overview'],
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'DISBURSEMENT.ADMIN', 'DISBURSEMENT.WRITE', 'DISBURSEMENT.READ']),
              //   title: 'member',
              // },
              // {
              //   label: 'Shift Scheduler',
              //   routerLink: ['member/shiftscheduler'],
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ']),
              //   title: 'member',
              // },
              // {
              //   label: 'Attachments',
              //   routerLink: ['member/attachments'],
              //   icon: 'fa-solid fa-paperclip',
              //   visible: true
              //   // visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'SHIFT.ADMIN', 'SHIFT.WRITE', 'SHIFT.READ'])
              // },
              {
                label: 'Concerns',
                routerLink: ['/admin/concerns'],
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'APPLICANT.ADMIN', 'APPLICANT.WRITE', 'APPLICANT.READ']),
                title: 'member',
              },
              {
                label: 'Leaves',
                routerLink: ['/admin/leaves'],
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
                title: 'member',
              },
              {
                label: 'Identification',
                routerLink: ['/member/add-identification'],
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
                title: 'member',
              }
              // {
              //   label: 'Performance',
              //   routerLink: ['/admin/performance'],
              //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
              //   title: 'member',
              // },
            ]
          },
          /* Commented out due to System Requirements - Do Not Remove */
          // {
          //   label : 'Attendance',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
          //   title: 'attendance',
          //   routerLink: ['/admin/attendance'],
          //   icon: 'fa-solid fa-calendar',
          // },
          {
            label : 'Job',
            routerLink: ['job/opening'],
            icon: 'fa-solid fa-briefcase',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
            title: 'jobs',
          },
          // {
          //   label: 'Topsheets',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'TOPSHEET.ADMIN', 'TOPSHEET.WRITE', 'TOPSHEET.READ']),
          //   routerLink: ['topsheet/overview'],
          //   icon: 'fa-solid fa-file-spreadsheet',
          //   title: 'topsheet',
          //   expanded: false,
          //   items: [
          //     // {
          //     //   label: 'Overview',
  
          //     //   visible: true
          //     // },
          //     // {
          //     //   label: 'Create',
          //     //   routerLink: ['topsheet/create'],
          //     //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'TOPSHEET.ADMIN', 'TOPSHEET.WRITE']),
          //     //   icon: 'fa-solid fa-file-plus'
          //     // },
          //     {
          //       label: 'Rates',
          //       routerLink: ['topsheet/rate'],
          //       icon: 'fa-solid fa-list-ol',
          //       title: 'topsheet',
          //       visible: true
          //     },
          //     {
          //       label: 'NFC Report',
          //       visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'NFC.WRITE', 'NFC.ADMIN', 'NFC.READ']),
          //       routerLink: ['topsheet/nfc-report'],
          //       icon: 'fa-solid fa-nfc-pen',
          //       title: 'topsheet',
          //       // routerLink: ['payout/create']
          //     },
          //     {
          //       label: 'Payslips',
          //       visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'SOMA.WRITE', 'SOMA.ADMIN', 'SOMA.READ']),
          //       routerLink: ['topsheet/view-soma'],
          //       icon: 'fa-solid fa-file-invoice-dollar',
          //       title: 'topsheet',
          //       // routerLink: ['payout/create']
          //     },
          //   ]
          // },
          // {
          //   label: 'Payout',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PAYOUT.ADMIN', 'PAYOUT.WRITE', 'PAYOUT.READ']),
          //   routerLink: ['payout/overview'],
          //   icon: 'fa-solid fa-hand-holding-dollar',
          //   title: 'payout',
          //   items: [
          //     // {
          //     //   label: 'Payout',
          //     //   routerLink: ['payout/overview'],
          //     //   icon: 'fa-solid fa-file-user',
          //     //   visible: true
          //     // },
          //     // {
          //     //   label: 'Create',
          //     //   routerLink: ['payout/create'],
          //     //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PAYOUT.ADMIN', 'PAYOUT.WRITE']),
          //     //   icon: 'fa-solid fa-file-plus'
          //     // }
          //   ]
          //   // routerLink: ['payout/create']
          // },
          // {
          //   label: 'Clients',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'CLIENT.ADMIN', 'CLIENT.WRITE', 'CLIENT.READ']),
          //   routerLink: ['client/overview'],
          //   icon: 'fa-solid fa-sitemap',
          //   title: 'client',
          // },
          {
            label: 'Offices',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'CLIENT.ADMIN', 'CLIENT.WRITE', 'CLIENT.READ']),
            routerLink: ['client/offices'],
            icon: 'fa-solid fa-sitemap',
            expanded: false,
            title: 'offices',
            items: [
              {
                label: 'Divisions',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'CLIENT.ADMIN', 'CLIENT.WRITE', 'CLIENT.READ']),
                routerLink: ['client/divisions'],
                icon: 'fa-solid fa-sitemap',
                title: 'divisions',
              },
              {
                label: 'Sections',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'CLIENT.ADMIN', 'CLIENT.WRITE', 'CLIENT.READ']),
                routerLink: ['client/sections'],
                icon: 'fa-solid fa-sitemap',
                title: 'sections',
              },
            ]
          },
          // {
          //   label: 'Billing',
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'BILLING.ADMIN', 'BILLING.WRITE', 'BILLING.READ']),
          //   routerLink: ['billing/overview'],
          //   icon: 'fa-solid fa-money-bill-simple-wave',
          //   expanded: false,
          //   title: 'billing',
          //   items: [
          //     // {
          //     //   label: 'Overview',
          //     //   routerLink: ['billing/overview'],
          //     //   icon: 'fa-solid fa-money-bill-simple-wave',
          //     //   visible: true
          //     // },
          //     // {
          //     //   label: 'Create',
          //     //   routerLink: ['billing/create'],
          //     //   icon: 'fa-solid fa-file-plus',
          //     //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'BILLING.WRITE', 'BILLING.ADMIN']),
          //     // },
          //     {
          //       label: 'SOA',
          //       routerLink: ['billing/soa'],
          //       icon: 'fa-solid fa-file-spreadsheet',
          //       title: 'billing',
          //       visible: true
          //     },
          //     {
          //       label: 'Books/Forms',
          //       routerLink: ['bookform'],
          //       icon: 'fa-solid fa-book',
          //       title: 'billing',
          //       visible: true
          //     },
          //     {
          //       label: 'Accounting',
          //       routerLink: ['admin/accounting'],
          //       icon: 'fa-solid fa-file-spreadsheet',
          //       title: 'billing',
          //       visible: true
          //     },
          //     {
          //       label: 'Chart of Accounts',
          //       routerLink: ['account/chart-of-accounts'],
          //       icon: 'fa-solid fa-list-ol',
          //       title: 'billing',
          //       visible: true
          //     }
          //   ]
          //   // routerLink: ['payout/create']
          // },
          // {
          //   label: 'Books / Forms',
          //   routerLink: ['bookform'],
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'BOOKS.WRITE', 'BOOKS.READ', 'BOOKS.ADMIN']),
          //   // icon: 'fa-solid fa-book'
          //   items: [
          //     {
          //       label: 'Overview',
          //       routerLink: ['bookform'],
          //       icon: 'fa-solid fa-book',
          //       visible: true
          //     },
          //     {
          //       label: 'Accounting',
          //       routerLink: ['admin/accounting'],
          //       icon: 'fa-solid fa-file-spreadsheet',
          //       visible: true
          //     }
          //   ]
          // },
          // {
          //   label: 'Chart of Accounts',
          //   routerLink: ['account/chart-of-accounts'],
          //   visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ACCOUNTS.WRITE', 'ACCOUNTS.READ', 'ACCOUNTS.ADMIN']),
          //   // icon: 'fa-solid fa-book'
          //   items: [
          //     {
          //       label: 'Overview',
          //       routerLink: ['account/chart-of-accounts'],
          //       icon: 'fa-solid fa-list-ol',
          //       visible: true
          //     }
          //   ]
          // },
          {
            label: 'Users',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ADMACCT.ADMIN', 'ADMACCT.WRITE', 'ADMACCT.READ', 'ROSTER.WRITE', 'ROSTER.READ', 'ROSTER.ADMIN']),
            routerLink: ['admin/users'],
            icon: 'fa-solid fa-users',
            title: 'users',
            expanded: false,
            items: [
              {
                label: 'Admin',
                routerLink: ['admin/users'],
                icon: 'fa-solid fa-users',
                title: 'users',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'ADMACCT.ADMIN', 'ADMACCT.WRITE', 'ADMACCT.READ'])
              },
              {
                label: 'Members',
                routerLink: ['admin/members'],
                icon: 'fa-solid fa-screen-users',
                title: 'users',
                visible: true
              },
              {
                label: 'Modules',
                routerLink: ['/member-modules/overview'],
                icon: 'fa-solid fa-duotone',
                title: 'users',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR',  'ROSTER.ADMIN']),
              },
            ]
            // routerLink: ['payout/create']
          },
          {
            label: 'Performance',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PERFORMANCE.ADMIN']),
            routerLink: ['admin/performance/opcr'],
            icon: 'fa-solid fa-briefcase',
            title: 'performance',
            expanded: false,
            items: [
              {
                label: 'OPCR',
                routerLink: ['admin/performance/opcr'],
                icon: 'fa-solid fa-users',
                title: 'performance',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PERFORMANCE.ADMIN'])
              },
              {
                label: 'IPCR',
                routerLink: ['admin/performance/ipcr'],
                icon: 'fa-solid fa-screen-users',
                title: 'performance',
                visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'PERFORMANCE.ADMIN'])
              },
            ]
            // routerLink: ['payout/create']
          },
          {
            label: 'LMS',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR', 'LMS.ADMIN', 'LMS.READ']),
            routerLink: ['admin/lms/home'],
            icon: 'fa-solid fa-book',
            title: 'lms',
          },
          {
            label: 'Communication',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
            routerLink: ['admin/communication'],
            icon: 'fa-solid fa-comments',
            title: 'communication',
          },
          {
            label: 'Settings',
            visible: await this.permissionService.hasPermission(['ADMINISTRATOR']),
            routerLink: ['admin/settings'],
            icon: 'fa-solid fa-gear',
            title: 'config',
          },
        ];
      }
      const isMember = await this.permissionService.hasPermission(['MEMBER']);
      const entityID = this.keycloakService.getKeycloakInstance().tokenParsed?.sub;
      if (this.currentRoute.includes("member/lms")){

        // LMS ROUTES
        this.apollo.watchQuery<Query>({
          query: CLIENT_ACCESS_QUERY,
          variables: {
            entityID
          }
        }).valueChanges.subscribe(async ({data, loading}) => {
          const clientAccess = data?.clientModules;
          this.items = [...this.items,
            {
              label: 'Member',
              visible: isMember,
              routerLink: ['admin/users'],
              items: [
                {
                  label: 'Home',
                  routerLink: ['member/lms/home'],
                  icon: 'fa-regular fa-objects-column',
                  // visible: isMember && await this.permissionService.hasPermission(['LMS.WRITE', 'LMS.ADMINISTRATOR', 'LMS.READ']), 
                },
                // {
                //   label: 'Announcement',
                //   routerLink: ['member/lms/announcement'],
                //   icon: 'fa-regular fa-bullhorn',
                //   visible: isMember,
                // },
                {
                  label: 'Trainings',
                  routerLink: ['member/lms/trainings'],
                  icon: 'fa-regular fa-graduation-cap',
                  visible: isMember && await this.permissionService.hasPermission(['LMS.WRITE', 'LMS.ADMINISTRATOR', 'LMS.READ'])
                },
                // {
                //   label: 'Lessons',
                //   routerLink: ['member/lms/lessons'],
                //   icon: 'fa-regular fa-book',
                //   visible: isMember
                // },
                {
                  label: 'Tests',
                  routerLink: ['member/lms/quiz'],
                  icon: 'fa-regular fa-lightbulb',
                  visible: isMember && await this.permissionService.hasPermission(['LMS.WRITE', 'LMS.ADMINISTRATOR', 'LMS.READ'])
                },
                // {
                //   label: 'Assignment',
                //   routerLink: ['member/lms/assignment'],
                //   icon: 'fa-regular fa-clipboard',
                //   visible: isMember
                // },
                // {
                //   label: 'Grades',
                //   routerLink: ['member/lms/grades'],
                //   icon: 'fa-regular fa-award',
                //   visible: isMember
                // },
                // {
                //   label: 'Enrollment',
                //   routerLink: ['member/lms/enrollment'],
                //   icon: 'fa-regular fa-files',
                //   visible: isMember
                // },
                // {
                //   label: 'Certificates',
                //   routerLink: ['member/lms/certificates'],
                //   icon: 'fa-regular fa-file-certificate',
                //   visible: isMember
                // },
                // {
                //   label: 'File Storage',
                //   routerLink: ['lms/file-storage'],
                //   icon: 'fa-regular fa-file',
                //   visible: isMember
                // },
                // {
                //   label: 'Inbox',
                //   routerLink: ['lms/inbox'],
                //   icon: 'fa-regular fa-inbox',
                //   visible: isMember
                // },
                // {
                //   label: 'Settings',
                //   routerLink: ['lms/setting'],
                //   icon: 'fa-regular fa-gear',
                //   visible: isMember
                // },
                {
                  label: 'Sign Out',
                  routerLink: ['signout'],
                  icon: 'fa-regular fa-square-left',
                  visible: isMember
                },
              ]
            },
  
          ];
          console.log(clientAccess);
        });
      } else {
        this.apollo.watchQuery<Query>({
          query: CLIENT_ACCESS_QUERY,
          variables: {
            entityID
          }
        }).valueChanges.subscribe(async ({data, loading}) => {
          const clientAccess = data?.clientModules;
          this.items = [...this.items,
            // {
            //   label: 'Member',
            //   visible: isMember,
            //   routerLink: ['admin/users'],
            //   items: [
            //   ]
            //   // routerLink: ['payout/create']
            // },
            {
              label: 'Profile',
              routerLink: ['performance'],
              icon: 'fa-solid fa-user',
              title: 'profile',
              visible: isMember
            },
            /* Commented out due to System Requirements - Do Not Remove */
            // {
            //   label: 'Attendance',
            //   routerLink: ['dtr'],
            //   icon: 'fa-solid fa-calendar',
            //   title: 'attendance',
            //   visible: isMember
            // },
            // {
            //   label: 'Overtime Request',
            //   routerLink: ['ot-request'],
            //   icon: 'fa-solid fa-clock',
            //   title: 'overtime',
            //   visible: isMember
            // },
            {
              label: 'Concerns',
              routerLink: ['/concerns'],
              icon: 'fa-solid fa-comment-exclamation',
              title: 'concerns',
              visible: clientAccess?.some((ca: any) => ca.HR_MODULE?.MODULE_NAME === 'CONCERNS')
            },
            /* Commented out due to System Requirements - Do Not Remove */
            // {
            //   label: 'Leaves',
            //   routerLink: ['leaves'],
            //   icon: 'fa-solid fa-person-walking',
            //   title: 'leaves',
            //   visible: clientAccess?.some((ca: any) => ca.HR_MODULE?.MODULE_NAME === 'SOMA')
            // }, // VISIBLE OF LEAVES MUST BE CHANGED SOON (ONLY USED AS A BANDAID SOLUTION)
            // {
             /* Commented out due to System Requirements - Do Not Remove */
            //   label: 'Payslips',
            //   routerLink: ['soma'],
            //   icon: 'fa-solid fa-file-invoice-dollar',
            //   title: 'soma',
            //   // visible: clientAccess?.some((ca: any) => ca.HR_MODULE?.MODULE_NAME === 'SOMA')
            //   // visible: isMember && await this.permissionService.hasPermission(['PAYOUT.VIEW'])
            //   visible: isMember,
            // },
            {
              label: 'Performance',
              // visible: isMember && await this.permissionService.hasPermission(['LMS.ADMIN', 'LMS.READ', 'LMS.WRITE']),
              visible: isMember,
              routerLink: ['member/performance/opcr'],
              icon: 'fa-solid fa-briefcase',
              title: 'performance',
              expanded: false,
              items: [
                {
                  label: 'OPCR',
                  routerLink: ['member/performance/opcr'],
                  icon: 'fa-solid fa-users',
                  title: 'performance',
                  // visible: isMember && await this.permissionService.hasPermission(['PERFORMANCE.ADMIN', 'PERFORMANCE.READ'])
                  visible: isMember,
                },
                {
                  label: 'IPCR',
                  routerLink: ['member/performance/ipcr'],
                  icon: 'fa-solid fa-screen-users',
                  title: 'performance',
                  visible: isMember,
                  // visible: isMember && await this.permissionService.hasPermission(['PERFORMANCE.ADMIN', 'PERFORMANCE.READ', 'PERFORMANCE.WRITE']),
                },
              ]
              // routerLink: ['payout/create']
            },
            {
              label: 'LMS',
              routerLink: ['member/lms/home'],
              icon: 'fa-solid fa-chalkboard-user',
              title: 'lms',
              // visible: isMember && await this.permissionService.hasPermission(['LMS.Admin', 'LMS.Write', 'LMS.Read'])
              visible: isMember

            },
  
          ];
          console.log(clientAccess);
        });
      }

      console.log("ITEMS", this.items);

      if (this.isUserLoggedIn){
        this.keycloakService.loadUserProfile().then(r => {
          this.appUser = r;
        });
      }

    });


  }

  openWindow(url: Array<string>){
      const urlTree = this.router.createUrlTree([url[0]]);
      console.log("URL", urlTree);
      const fullUrl = `${window.location.origin}${this.router.serializeUrl(urlTree)}`;
      console.log("ROUTE", fullUrl);
      // this.currentRoute = fullUrl;
      window.open(fullUrl, '_blank');
  }

  // apollo.watchQuery<Query>({
  //   query: checkRegistered
  // }).valueChanges.subscribe(({data, loading})=>{
  //   if(!data.isRegistered){
  //     router.navigate(['/registration']);
  //   }
  // });

  async ngOnInit(): Promise<void> {
    this.currentRoute = window.location.href;
  }

  async LogOut(): Promise<void> {
    await this.keycloakService.logout(window.location.origin + '/');
  }

  async ngAfterViewInit(): Promise<void> {
  }

  toggleSidebar(): void {
    this.sidebarState = !this.sidebarState;
  }

  navigateToLink(routerLink: any, label: any): void {
    if (routerLink === 'signout'){
      this.LogOut();
    }else {
      this.currentTitle = label;
      this.currentRoute = routerLink;
      this.router.navigate([routerLink]).then(m => {
        this.toggleSidebar();
      });
    }

  }

  checkCurrentRouteIfNotLMS() {
    // console.log("ROUTE", this.currentRoute)
    if (this.currentRoute.includes("member/lms") || this.currentRoute.includes("admin/lms")){
      return false;
    }
    return true;
  }

  checkRegistration() {
    // console.log("ROUTE", this.currentRoute)
    if (this.currentRoute.includes("registration")){
      return true;
    }
    return false;
  }

  isCurrentRoute(route: any) {
    if (route === '' && (this.currentRoute.charAt(this.currentRoute.length - 1) == '/' || this.currentRoute.charAt(this.currentRoute.length - 1) == ''))
      return true; 
    if (this.currentRoute.includes(route) && route != ''){
      return true;
    }
    return false;
  }

  isCurrentNavItem(title: any){
    if (this.currentTitle.includes(title)){
      return true;
    }
    return false;
  }

  getGreeting() {
    const today = new Date()
    const hour = today.getHours();
    if (hour < 12){
      return "Good Morning!"
    }else if ( hour >= 12 && hour < 18){
      return "Good Afternoon!"
    } else {
      return "Good Evening!"
    }
  }

  openProfile() {
    this.currentTitle = 'profile';
    console.log("this.admin", this.isAdmin);
    if (this.isAdmin){
      this.currentRoute = '/admin/lms/profile';
      this.router.navigate(['/admin/lms/profile']).then(m => {
        this.toggleSidebar();
      });
    } else {
      this.currentRoute = '/member/lms/profile';
      this.router.navigate(['/member/lms/profile']).then(m => {
        this.toggleSidebar();
      });
    }
  }
}
